import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { SapC4CResourceDataset } from 'app/model/dataset/sapc4c-resource.dataset';
import { Metamodel } from 'app/model/base/model';
import { SapC4CLinkedService } from 'app/model/linkedservice/sapc4c.linkedservice';
import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { maxConcurrentConnectionsMetadata, httpRequestTimeoutMetadata } from '../consts/metadata-consts';

const sapC4CSinkWriteBehaviors = [writeBehaviorOptionValues.insert, writeBehaviorOptionValues.update];
export const sapC4CResourceMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(SapC4CResourceDataset).name,
    displayName: stringResources.SapCloudForCustomer_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(SapC4CLinkedService).name],
    isSource: true,
    isSink: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-sap_cloud_for_customer'
    },
    tableNameDisplay: stringResources.PathLabel,
    tableNamePlural: stringResources.PathsLabel,
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    notSupportTypeConversion: true,
    copySourceControls: [httpRequestTimeoutMetadata],
    category: ['ServicesApps'],
    copySinkControls: [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            options: writeBehaviorAllOptions
                .filter((option) => sapC4CSinkWriteBehaviors.indexOf(option.value) >= 0)
        },
        {
            type: 'parameterizable',
            child: {
                type: 'textbox-number',
                bind: 'writeBatchSize',
                label: stringResources.ModelName_WriteBatchSize,
                inputType: 'number',
                defaultValue: 10,
                min: 0
            },
            dynamicContentTextClass: 'input-spaced'
        },
        maxConcurrentConnectionsMetadata,
        httpRequestTimeoutMetadata
    ]
};
